import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/posts/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderActions"] */ "/app/src/components/layout/header-actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuLink"] */ "/app/src/components/layout/menu-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/app/src/components/layout/mobile-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileUserButton"] */ "/app/src/components/layout/mobile-user-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserMenu"] */ "/app/src/components/layout/user-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SimpleLanguageSelector.tsx");
